import React from 'react';
import { useAuth } from '../hooks/useAuth';

const Navbar = () => {
  const { user, logout } = useAuth();

  const getInitials = (name) => {
    return name
      .split(' ')
      .map(part => part[0])
      .join('')
      .toUpperCase();
  };

  return (
    <div className="navbar">
      <div></div>
      <div className="user-profile">
        <span>{user.name}</span>
        <div className="user-avatar">
          {getInitials(user.name)}
        </div>
        <button className="btn btn-secondary" onClick={logout}>
          Logout
        </button>
      </div>
    </div>
  );
};

export default Navbar;